<template>
    <!-- 街道地面 -->
    <div class="ground">
        <div class="groundTips">
        点击地上的道具可以将它收入囊中哦！
        </div>
        <div class="groundLayer">
            <div v-show="curItemList.length == 0" v-for="n in GROUND_ITEM_LIMIT" v-bind:key="n">
                <div class="groundItems">
                </div>
            </div>
        </div>
        <div class="groundLayer">
            <div class="itemdiv" v-show="curItemList.length > 0" v-for="(item,index) in curItemList" v-bind:key="index">
                <div class="groundItems">
                <a v-if="item != null" :id="'item_' +index" @click="pickitem(cityMap.id, index);" ref="item">
                  <FantasyItemCard :item="item" :show-name="false" :show-info="false" :show-desc-on-click="false"></FantasyItemCard>
                </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getRequest, postJson, onResult} from '../../utils/api'
import Message from 'element-ui/lib/message'
import FantasyItemCard from '../common/FantasyItemCard'
export default {
  name: 'streetGround',
  components: { FantasyItemCard },
  props:{
    itemList: Array,
    cityMap: Object
  },
  data() {
    return {
        curItemList: []
    };
  },
  watch: {
      itemList: {
        handler(newVal, oldVal) {
          if (newVal != null) {
            this.curItemList = newVal;
          }
        }
      }
  },
  methods: {
    updateItemList: function(items) {
        this.curItemList = items;
    },
    pickitem: function(mapId, itemId) {
        //alert(mapId + ", " + itemId);
        const _this = this;
        postJson('/item/item/pickItem', {
          mapId: mapId,
          itemId: itemId
        }).then(resp=> {
            onResult(resp, {
              success: data => {
                if (data.data && data.data.message == "noitem") {
                    Message.info("一阵残影闪过，你眼睁睁的看着快到手的鸭子飞走了~~~");
                } else {
                    // 称号熟练度（混子→体力上限 / 脚夫→疲劳上限）：只有捡「系统刷出来」的道具才可能涨
                    // （捡自己/别人扔下的不会给 titleMastery，后端按运行时白名单判定）
                    const mastery = data.data && data.data.titleMastery;
                    // 有熟练度回显时并进同一条 toast，别右上角连弹两条
                    Message.success(mastery && mastery.text ? "道具拾取成功，" + mastery.text : "道具拾取成功");
                    // D13 起拾取消耗疲劳，成功后刷新用户状态让疲劳数实时更新
                    _this.$store.dispatch('user/fetchUserDetail');
                }
                _this.$set(_this.curItemList, itemId, null);
              }
            });
        });
    }
  },
  mounted: function () {
    this.$root.eventHub.$on('items', this.updateItemList);
  },
  beforeDestroy: function () {
    this.$root.eventHub.$off('items', this.updateItemList);
  },
}
</script>

<style scoped>
.ground a {
    cursor: pointer;
    color: blue;
}
.ground {
	height:140px;
	margin:5px;
	align-items:center;
}
.ground .groundTips {
	text-align:center;
	margin:5px;
  font-size: 12px;
}
.ground .groundLayer {
    display: grid;
    grid-template-columns: repeat(10, 42px);
    gap: 0;
    justify-content: center;
    margin: 0 auto;
}
.ground .groundItems {
	position:relative;
	border:1px solid #bbb;
	width:42px;
	height:42px;
    box-sizing: border-box;
    margin: -1px;
  background: #fff;
}
.ground .groundItems img {
	width:100%;
	border:0;
}
.itemdiv .stackCount {
  position: absolute;
  bottom: 0px;
  font-size: 0.7em;
  width: 100%;
  background-color: rgba(233, 141, 66, 0.4);
}
.ground ::v-deep .img-wrapper {
  display: block;
}
.ground ::v-deep .img-wrapper img {
  width: 100%;
  height: auto;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .ground {
    height: auto;
    max-width: 100%;
    overflow: hidden;
  }
  /* 1fr 的最小轨道宽是内容固有宽（道具图 40px），10 列会撑破小屏——minmax(0,1fr) 强制平分 */
  .ground .groundLayer {
    grid-template-columns: repeat(10, minmax(0, 1fr));
    width: 100%;
    padding: 0 4px;
    box-sizing: border-box;
  }
  .ground .groundItems {
    width: 100%;
    min-width: 0;
    aspect-ratio: 1;
    max-width: none;
    margin: 0;
  }
  /* 卡片链路逐级撑满格子，图片按格缩放 */
  .ground .itemdiv,
  .ground a {
    display: block;
    width: 100%;
  }
  .ground ::v-deep .fantasy-item-card {
    display: block;
    width: 100%;
  }
  .ground ::v-deep .img-wrapper {
    display: block;
    width: 100%;
  }
  .ground ::v-deep .img-wrapper img {
    width: 100%;
    height: auto;
  }
}
</style>